import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const PREVIEW_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/oGEsxppJ6SfvkGkbi7ukjo/IMG_3023.jpg',
  alt: 'Capítulo 1 — ¿Qué es la Biodecodificación?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uTsAgzqMCDukWkjBPopWkT/IMG_3025.jpg',
  alt: 'Capítulo 2 — Los 7 Sistemas del Cuerpo y su Emocionalidad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hTuWv9UPTBw45xRfA7BHUr/IMG_3026.jpg',
  alt: 'Capítulo 3 — Los 5 tipos de lealtades familiares'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/65mkNdwMgRQtGDUWRGpQfd/IMG_3024.jpg',
  alt: 'Principio 4 — Ley de la Recurrencia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dtoTpmivNK3Pzm3Pcf54GM/IMG_3027.jpg',
  alt: 'Capítulo 2 — Los 5 Errores Más Comunes al Abrir una Sesión'
}];
export function PreviewCarousel() {
  const [ref, vis] = useReveal();
  const [current, setCurrent] = useState(0);
  const goTo = (index: number) => {
    setCurrent(index);
  };
  const prev = () => {
    setCurrent(c => c === 0 ? PREVIEW_IMAGES.length - 1 : c - 1);
  };
  const next = () => {
    setCurrent(c => c === PREVIEW_IMAGES.length - 1 ? 0 : c + 1);
  };
  return <section className="bg-[#EFEAE0] py-5 md:py-10 px-4 sm:px-6 border-t border-[#2E4F48]/5" data-id="element-245">
      <div className="container mx-auto max-w-4xl" data-id="element-246">
        <div ref={ref} className={`reveal text-center mb-10 ${vis ? 'is-visible' : ''}`} data-id="element-247">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#1C3B36]" data-id="element-248">
            👀 Mirá por dentro
          </h2>
          <p className="text-[#44574F] text-lg font-medium" data-id="element-249">
            Páginas reales del material que vas a recibir
          </p>
        </div>

        <div className="relative" data-id="element-250">
          {/* Main Image */}
          <div className="relative overflow-hidden rounded-xl border border-[#2E4F48]/20 bg-[#ffffff] shadow-lg" data-id="element-251">
            <img src={PREVIEW_IMAGES[current].src} alt={PREVIEW_IMAGES[current].alt} className="w-full h-auto max-h-[70vh] object-contain mx-auto" data-id="element-252" />

            {/* Navigation Arrows */}
            <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 border border-[#2E4F48]/20 flex items-center justify-center text-[#1C3B36] hover:bg-[#C2683D] hover:text-white hover:border-[#C2683D] transition-all z-10 shadow-sm" aria-label="Anterior" data-id="element-253">
              ‹
            </button>
            <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 border border-[#2E4F48]/20 flex items-center justify-center text-[#1C3B36] hover:bg-[#C2683D] hover:text-white hover:border-[#C2683D] transition-all z-10 shadow-sm" aria-label="Siguiente" data-id="element-254">
              ›
            </button>
          </div>

          {/* Caption */}
          <p className="text-center text-[#44574F] text-sm mt-4 font-bold" data-id="element-255">
            {PREVIEW_IMAGES[current].alt}
          </p>

          {/* Thumbnails */}
          <div className="flex justify-center gap-2 mt-4 overflow-x-auto pb-2" data-id="element-256">
            {PREVIEW_IMAGES.map((img, i) => <button key={i} onClick={() => goTo(i)} className={`flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden border-2 transition-all ${i === current ? 'border-[#C2683D] shadow-md' : 'border-[#2E4F48]/10 opacity-60 hover:opacity-100'}`} data-id="element-257">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-258" />
              </button>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-3" data-id="element-259">
            {PREVIEW_IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-[#C2683D] w-6' : 'bg-[#2E4F48]/20'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-260" />)}
          </div>
        </div>
      </div>
    </section>;
}